module.exports = {"TXTWCL_Something_went_wrong":{"id":"TXTWCL_Something_went_wrong","defaultMessage":"Nešto je pošlo po zlu","track":"Something went wrong"}}